/* C.C.D. UX helpers
   1) size tables: show a "← SCROLL →" hint when the table is wider than its box (<=750px)
   2) cart "ALSO ON FILE": pick size (and colour) inside the card, add via /cart/add.js, reload the cart */
(function () {
  // ---- 1) size-table scroll hint ----
  function setupHint(wrap) {
    if (wrap.dataset.hintReady) return;
    wrap.dataset.hintReady = '1';
    var hint = document.createElement('p');
    hint.className = 'ccd-scroll-hint';
    hint.textContent = '← SCROLL →';
    hint.hidden = true;
    wrap.parentNode.insertBefore(hint, wrap.nextSibling);
    function check() { hint.hidden = !(wrap.clientWidth > 0 && wrap.scrollWidth > wrap.clientWidth + 2); }
    if (window.ResizeObserver) new ResizeObserver(check).observe(wrap); else window.addEventListener('resize', check);
    check();
  }
  document.querySelectorAll('.ccd-size-wrap').forEach(setupHint);

  // ---- 2) cart suggestions ----
  var section = document.querySelector('.ccd-suggest');
  if (!section) return;
  var MSG_PICK = section.getAttribute('data-msg-pick') || '';
  var MSG_ERR = section.getAttribute('data-msg-error') || '';

  function data(card) {
    if (!card._variants) {
      try { card._variants = JSON.parse(card.querySelector('.ccd-sug-json').textContent); } catch (e) { card._variants = []; }
    }
    return card._variants;
  }
  function pos(card, name) { return parseInt(card.getAttribute(name), 10) || 0; }
  function colour(card) {
    var chip = card.querySelector('.ccd-chip-btn.is-on');
    return chip ? chip.getAttribute('aria-label') : null;
  }
  function opt(v, p) { return p === 1 ? v.o1 : p === 2 ? v.o2 : p === 3 ? v.o3 : null; }
  // refresh which sizes are available for the chosen colour
  function refresh(card) {
    var cp = pos(card, 'data-color-pos'), sp = pos(card, 'data-size-pos'), col = colour(card);
    card.querySelectorAll('.ccd-sug-sizes input').forEach(function (r) {
      var ok = data(card).some(function (v) {
        return v.a && (!sp || opt(v, sp) === r.value) && (!cp || !col || opt(v, cp) === col);
      });
      r.disabled = !ok;
      r.parentNode.classList.toggle('is-so', !ok);
      if (!ok && r.checked) r.checked = false;
    });
  }
  function pickVariant(card) {
    var cp = pos(card, 'data-color-pos'), sp = pos(card, 'data-size-pos'), col = colour(card);
    var sel = card.querySelector('.ccd-sug-sizes input:checked');
    var size = sel ? sel.value : null;
    if (sp && !size) return null;
    return data(card).find(function (v) {
      return v.a && (!sp || opt(v, sp) === size) && (!cp || !col || opt(v, cp) === col);
    }) || null;
  }
  function add(card, v, btn, msg) {
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { msg.textContent = MSG_ERR; btn.disabled = false; });
  }

  section.addEventListener('click', function (e) {
    var card = e.target.closest('.ccd-sug');
    if (!card) return;
    var msg = card.querySelector('.ccd-sug-msg');
    if (e.target.closest('[data-sug-open]')) {
      var openBtn = card.querySelector('[data-sug-open]');
      var panel = card.querySelector('.ccd-sug-panel');
      // no size option -> add straight away
      if (!pos(card, 'data-size-pos')) {
        var v0 = pickVariant(card);
        if (v0) { add(card, v0, openBtn, msg); return; }
        return;
      }
      panel.hidden = false; openBtn.hidden = true; refresh(card);
      return;
    }
    if (e.target.closest('[data-sug-confirm]')) {
      var btn = card.querySelector('[data-sug-confirm]');
      var v = pickVariant(card);
      if (!v) { msg.textContent = MSG_PICK; return; }
      msg.textContent = '';
      add(card, v, btn, msg);
      return;
    }
    if (e.target.closest('.ccd-chip-btn')) setTimeout(function () { refresh(card); msg.textContent = ''; }, 0);
  });
  section.addEventListener('change', function (e) {
    var card = e.target.closest('.ccd-sug');
    if (card) card.querySelector('.ccd-sug-msg').textContent = '';
  });
})();
